import styles from "./index.module.scss"
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ComposedChart,
  Bar,
  LabelList,
  Text,
  ResponsiveContainer,
} from "recharts"

export const ParetoChartComponent = ({ data }) => {

  const formatYAxis = (tick) => {
    return `${tick}%`
  }

  return (
    <div
      id="chart-container"
      style={{ width: "100%", position: "relative", marginTop: "2rem" }}
    >
      <ResponsiveContainer className={styles.chart}>
        <ComposedChart data={data} margin={{ top: 25, bottom: 25 }}>
          <XAxis
            dataKey="cause_cdescription"
            interval={0}
            axisLine={false}
            tickLine={false}
            tick={<CustomXAxisTickLegend />}
          />
          <YAxis yAxisId="left" interval={0} axisLine={false} tickLine={false} />
          <YAxis
            yAxisId="right"
            orientation="right"
            domain={[0, 100]}
            interval={0}
            tickFormatter={formatYAxis}
            axisLine={false}
            tickLine={false}
          />

          <CartesianGrid strokeDasharray="0" vertical={false} stroke="#CCD1D6" />
          <Bar yAxisId="left" dataKey="runs_ncount" barSize={32} fill="#6CB6E3">
            <LabelList dataKey="runs_ncount" />
          </Bar>
          <Line
            type="monotone"
            yAxisId="right"
            dataKey="runs_npercentage"
            stroke="#FF3541"
            label={<CustomLineLabel />}
            dot={false}
            strokeWidth={4}
            animationDuration={500}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

const CustomXAxisTickLegend = (props) => {
  const { x, y, payload } = props
  const words = payload.value.split(" ") // Quebrando o texto em palavras
  const lineHeight = 12 // Ajuste a altura da linha conforme necessário

  return (
    <g transform={`translate(${x}, ${y})`}>
      {words.map((word, index) => (
        <text
          key={`top-causes-x-axis-label-${index}`}
          x={0}
          y={lineHeight * index + (lineHeight / 2)}
          textAnchor="middle"
          fill="#415364" // Cor do texto
          fontSize={12} // Tamanho da fonte
          fontWeight={600} // Peso da fonte
        >
          {word}
        </text>
      ))}
    </g>
  )
}

const CustomLineLabel = (props) => {
  const { x, y, value } = props
  return (
    <text
      x={x}
      y={y}
      dy={-10}
      color="#22272D"
      fontSize={12}
      fontWeight={600}
      textAnchor="middle"
      className={styles.topCausesPercentagText}
    >
      {value?.toLocaleString()}%
    </text>
  )
}
